import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import * as userService from '../components/Application/Services/userService';

const useCompanyStore = create(
  persist(
    (set, get) => ({
      company: null,
      isLoading: false,
      error: null,

      // Fetch company data
      fetchCompany: async () => {
        const jwt = localStorage.getItem('token');
        if (!jwt || jwt === 'null') {
          console.log('No JWT token found, skipping company fetch.');
          return null;
        }

        set({ isLoading: true, error: null });
        try {
          const { data } = await userService.getCompany();
          set({ company: data, isLoading: false });
          return data;
        } catch (error) {
          set({ error: error.message, isLoading: false });
          console.error('Failed to fetch company:', error);
          throw error;
        }
      },

      // Other actions
      setCompany: (company) => set({ company, error: null }),

      updateCompany: async (companyData) => {
        set({ isLoading: true, error: null });
        try {
          const response = await userService.addOrUpdateCompany(companyData);
          set({ company: response.data, isLoading: false });
          return response;
        } catch (error) {
          set({ error: error.message, isLoading: false });
          throw error;
        }
      },

      clearCompany: () => set({ company: null, error: null }),
    }),
    {
      name: 'company-storage',
    }
  )
);

export default useCompanyStore;
